/**
 * Indica si una empresa existe en el árbol de empresas (nodos con code y children).
 * Compara como texto porque localStorage y la URL entregan el código como string.
 */
export const containsCompany = (nodes, companyId) => {
    if (!companyId) {
        return false;
    }
    const target = String(companyId);
    return nodes.some(node =>
        String(node.code) === target || containsCompany(node.children || [], target));
};
